import { forwardRef } from "react";
import cx from "classnames";
import Link from "next/link";

import { Icon } from "common/ui/Icon";
import { Label } from "common/ui/Label";

import styles from "./SideBar.module.scss";

export interface PageLink {
  title: string,
  url: string,
}

interface Props {
  isOpen: boolean,
  close: () => void,
  links: PageLink[],
}

const SideBar = forwardRef<HTMLDivElement, Props>(({
  isOpen,
  close,
  links,
}, ref) => {
  return (
    <>
      <div
        ref={ref}
        className={cx(styles.SideBar, {
          [styles.show]: isOpen,
        })}
        role="menu"
      >
        <div className={styles.IconContainer}>
          <Icon
            icon="closeMajor"
            onClick={close}
            ariaLabel="close-sidebar"
          />
        </div>
        <div className={styles.Links}>
          {links.map((l) => (
            <Link
              key={l.title}
              className={styles.Link}
              href={l.url}
              onClick={close}
            >
              <Label variant="l1">{l.title}</Label>
            </Link>
          ))}
        </div>
      </div>
      {isOpen && (
        <div
          className={styles.BlackScreen}
          data-testid="black-screen"
        />
      )}
    </>
  );
})

SideBar.displayName = "SideBar";

export default SideBar;
